module.exports = __webpack_public_path__ + "assets/img/new03.abd90f8b.png";